import { z } from 'zod';

import { SAVED_FILTER_NAME_MAX_LENGTH, SAVED_FILTER_TYPES } from './constants';

export const zodSavedFilterTypeSchema = z.enum(SAVED_FILTER_TYPES);

export const zodSavedFilterClauseValueSchema = z.union([
  z.boolean(),
  z.number(),
  z.string(),
  z.array(z.union([z.boolean(), z.number(), z.string()])),
  z.null(),
]);

export const zodSavedFilterClauseSchema = z.object({
  field: z.string().min(1).max(128),
  value: zodSavedFilterClauseValueSchema.optional(),
});

export const zodSavedFilterResponseSchema = z.object({
  createdOn: z.string(),
  filters: z.array(zodSavedFilterClauseSchema),
  id: z.uuid(),
  modifiedOn: z.string(),
  name: z.string(),
  type: zodSavedFilterTypeSchema,
  userId: z.uuid(),
  version: z.number().int().min(1),
});

export const zodSavedFilterListResponseSchema = z.object({
  data: z.array(zodSavedFilterResponseSchema),
  hasNextPage: z.boolean().optional().default(false),
  paginatedCount: z.number().int(),
});

export const zodCreateSavedFilterPayloadSchema = z.object({
  filters: z.array(zodSavedFilterClauseSchema).max(50).optional(),
  name: z.string().min(1).max(SAVED_FILTER_NAME_MAX_LENGTH),
  type: zodSavedFilterTypeSchema,
});

export const zodUpdateSavedFilterPayloadSchema = z.object({
  expectedVersion: z.number().int().min(1),
  filters: z.array(zodSavedFilterClauseSchema).max(50).nullable().optional(),
  name: z
    .string()
    .min(1)
    .max(SAVED_FILTER_NAME_MAX_LENGTH)
    .nullable()
    .optional(),
});
